import { render, staticRenderFns } from "./SettingComponentVue.vue?vue&type=template&id=1993c619"
import script from "./SettingComponentVue.vue?vue&type=script&lang=js"
export * from "./SettingComponentVue.vue?vue&type=script&lang=js"
import style0 from "./SettingComponentVue.vue?vue&type=style&index=0&id=1993c619&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports